export enum SharedStoreSlices {
	Forms = 'forms'
}
